<template>
  <div class="main-PCSistemaPesado">
    <f7-actions
      class="content-action-sistemaPesado"
      :grid="true"
      :close-by-backdrop-click="false"
      :opened="actionsWeighingReading"
      @actions:closed="actionsWeighingReading = false"
    >
      <f7-actions-group>
        <f7-actions-label>
          {{ $t('production.weighingSystem.label') }}
        </f7-actions-label>
        <div class="content-action__input">
          <f7-input
            outline
            type="number"
            step=".001"
            clear-button
            :value="peso"
            @input="peso = $event.target.value"
          />
        </div>
        <div class="content-action__buttons">
          <f7-actions-button
            class="actions-button--cancelar"
            @click="actionsWeighingReading = false; $emit('event-close')"
          >
            {{ $t('common.cancel') }}
          </f7-actions-button>
          <f7-actions-button
            class="actions-button--guardar"
            @click="UpdatePalletWeight()"
          >
            {{ $t('common.confirm') }}
          </f7-actions-button>
        </div>
      </f7-actions-group>
    </f7-actions>
  </div>
</template>

<script>
import { Log, LogError } from '@/js/common/HIDebuggingSupport';
import ConexionTA from '@/js/services/traceability/APITraceability';
import { HiNotification, PreloaderGH } from '@/js/common/HINotificationSupport';

export default {
  name: 'PCSistemaPesado',

  props: {
    openWeighingReading: {
      type: Boolean,
      default: false,
    },
    weight: {
      type: Number,
      default: 0,
    },
    idANS: {
      type: Number,
      default: 0,
    },
  },

  emits: [
    'event-close',
    'update-weight',
  ],

  data() {
    return {
      actionsWeighingReading: false, // Contiene la fecha de la ultima actualización de ultimos volcados.
      peso: 0,
      idArticuloNumeroSerie: null,
    };
  },
  watch: {
    openWeighingReading(val) {
      if (val) {
        this.actionsWeighingReading = this.openWeighingReading;
      }
    },
    weight(val) {
      if (val) {
        this.peso = this.weight;
      }
    },
    idANS(val) {
      if (val) {
        this.idArticuloNumeroSerie = this.idANS;
      }
    },
  },
  methods: {
    async UpdatePalletWeight() {
      Log(this, this.UpdatePalletWeight.name);
      PreloaderGH(true, true, this.$t('production.weighingSystem.update.preloaderText'));
      const result = await ConexionTA.callUpdatePalletWeight(this.idArticuloNumeroSerie, this.peso);
      if (result.Valor) {
        PreloaderGH(false);
        HiNotification.Toast(this.$t('production.weighingSystem.update.successToastText'));
        this.$emit('update-weight');
      } else {
        PreloaderGH(false);
        HiNotification.Alert(result.Mensaje, this.$t('common.error'));
        LogError(this, this.UpdatePalletWeight.name, result.Mensaje);
      }
      PreloaderGH(false);
    },
  },
};
</script>

<style lang="scss">
.content-action-sistemaPesado {
  .actions-group {
    height: 200px;

    .actions-label {
      color: var(--his-slate-blue);
      font-size: 16px;
      display: flex;
      justify-content: center;
    }

    .content-action__input {
      display: flex;
      justify-content: center;
      width: 100%;

      .input {
        color: var(--his-slate-blue);
        padding: 10px 0;
        height: 30%;
        width: 40%;
      }
    }

    .content-action__buttons {
      display: flex;
      justify-content: space-between;

      .actions-button--cancelar {
        background: #fff;
        color: gray;

        .actions-button-text {
          font-size: 14px;
          text-transform: uppercase;
        }
      }

      .actions-button--guardar {
        background: #fff;
        color: green;

        .actions-button-text {
          font-size: 16px;
          text-transform: uppercase;
        }
      }
    }
  }
}
</style>
